import { AsyncPipe, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpStateService, HttpUiError } from './core/services/http-state.service';
 
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgIf, AsyncPipe],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  readonly loading$: Observable<boolean>;
  readonly lastError$: Observable<HttpUiError | null>;

  constructor(private readonly httpStateService: HttpStateService) {
    this.loading$ = this.httpStateService.loading$;
    this.lastError$ = this.httpStateService.lastError$;
  }

  cerrarError(): void {
    this.httpStateService.clearError();
  }
}
